import { garments } from "../data/garments";
import type { CurrentOrders, SentOrder } from "../types";

export function getOrderTotal(orders: CurrentOrders[string]) {
  return orders.reduce(
    (total, order) => total + Object.values(order.sizes).reduce((sum, count) => sum + count, 0),
    0,
  );
}

export function combineOrderHistory(currentOrders: CurrentOrders, sentOrders: SentOrder[]) {
  const history: CurrentOrders = {};

  function appendOrders(orders: CurrentOrders) {
    Object.entries(orders).forEach(([garment, garmentOrders]) => {
      history[garment] = [...(history[garment] ?? []), ...garmentOrders];
    });
  }

  appendOrders(currentOrders);
  sentOrders.forEach((delivery) => appendOrders(delivery.garments));

  Object.values(history).forEach((orders) => orders.sort((a, b) => b.date - a.date));
  return history;
}

function escapeCsv(value: string | number) {
  const stringValue = String(value);
  return /[;"\n]/.test(stringValue) ? `"${stringValue.replaceAll('"', '""')}"` : stringValue;
}

export function downloadOrderCsv(orders: CurrentOrders, selected: string[]) {
  const rows: Array<Array<string | number>> = [["Plagg", "Namn", "Storlek", "Antal"]];

  selected.forEach((garmentName) => {
    const sizeCounts: Record<string, number> = {};
    orders[garmentName]?.forEach((order) => {
      Object.entries(order.sizes).forEach(([size, count]) => {
        sizeCounts[size] = (sizeCounts[size] ?? 0) + count;
      });
    });
    const supplierName = garments.find((garment) => garment.name === garmentName)?.supplierName ?? "";
    Object.entries(sizeCounts).forEach(([size, count]) => {
      rows.push([garmentName, supplierName, size, count]);
    });
  });

  const csv = `\uFEFF${rows.map((row) => row.map(escapeCsv).join(";")).join("\n")}`;
  const url = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = `kils-ok-bestallning-${new Date().toISOString().slice(0, 10)}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
